import { SvgIcon, type SvgIconProps } from '@components/primitives/SvgIcon';

import Video from '../assets/icons/feather/Video.svg?react';

export function VideoIcon(props: SvgIconProps) {
  return <SvgIcon component={Video} inheritViewBox {...props} />;
}
